/**
 * Conversation — root shell для AI-диалогов.
 *
 * Варианты:
 *   - variant="drawer"  — full-height правый pane (640px / 100vw на мобильном).
 *                         Backdrop кликабельный, ESC закрывает.
 *   - variant="widget"  — bottom-right карточка (380×560 / bottom-sheet на мобильном).
 *                         Без backdrop на desktop, кликом-вне НЕ закрывается
 *                         (есть X в шапке).
 *
 * Контракт детей:
 *   <Conversation open onClose variant="drawer" ariaLabel="...">
 *     <ConversationHeader ... />
 *     <MessageStream ... />
 *     <Composer ... />
 *   </Conversation>
 *
 * См. .cursor/rules/conversation-ui.mdc для канона.
 */

import { useEffect } from 'react'

export default function Conversation({
    open,
    onClose,
    variant = 'drawer',
    ariaLabel,
    children,
}) {
    useEffect(() => {
        if (!open) return
        const onKey = (e) => {
            if (e.key === 'Escape') onClose?.()
        }
        window.addEventListener('keydown', onKey)
        return () => window.removeEventListener('keydown', onKey)
    }, [open, onClose])

    if (!open) return null

    if (variant === 'widget') {
        return (
            <div
                className="conversation conversation--widget"
                role="dialog"
                aria-label={ariaLabel}
            >
                {children}
            </div>
        )
    }

    return (
        <div
            className="conversation-overlay"
            onClick={onClose}
            role="presentation"
        >
            <div
                className="conversation conversation--drawer"
                role="dialog"
                aria-label={ariaLabel}
                aria-modal="true"
                onClick={(e) => e.stopPropagation()}
            >
                {children}
            </div>
        </div>
    )
}
